import React from "react";
import { withRouter } from "react-router-dom";

const ExtendedLink = ({ className, onClick, children }) => {
  return (
    <button className={className} onClick={onClick}>
      {children}
    </button>
  );
};

export default withRouter(ExtendedLink);
